import { render } from "./TheFooter.vue?vue&type=template&id=15681f1f&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=15681f1f&scoped=true&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15681f1f"]])

export default __exports__